import Cookies from 'js-cookie'

// Flag to indicate if tournament filters are managing hidden count
let tournamentFiltersActive = false;
let placeholderTimeout = null;

export const initFilters = () => {
    $('.filter-games-checkbox>input').on('click', function () {
        var $game = $(this).attr('id');
        const isChecked = $(this).prop('checked');
        
        if (isChecked) {
            Cookies.set($game, true, { expires: 365 });
            $(`div.games[data-game-text-id=${$game}]`).show();
        }
        else {
            Cookies.set($game, false, { expires: 365 });
            $(`div.games[data-game-text-id=${$game}]`).hide();
        }
        
        showHidePlaceholder();
        
        // Fire custom event for tournament filters to listen to
        const filterChangeEvent = new CustomEvent('gameFilterChange', {
            detail: {
                gameId: $game,
                isChecked: isChecked,
                activeFilters: getActiveFilters()
            }
        });
        document.dispatchEvent(filterChangeEvent);
    });

    $('.show_all_matches').on('click', function () {
        $('.filter-games-checkbox>input:not(:checked)').click();
        
        // Fire custom event after "show all" action is complete
        setTimeout(() => {
            const filterChangeEvent = new CustomEvent('gameFilterChange', {
                detail: {
                    gameId: 'all',
                    isChecked: true,
                    activeFilters: getActiveFilters(),
                    action: 'showAll'
                }
            });
            document.dispatchEvent(filterChangeEvent);
        }, 0);
    });
}

// Helper function to get currently active filters
const getActiveFilters = () => {
    const activeFilters = [];
    $('.filter-games-checkbox>input:checked').each(function() {
        activeFilters.push($(this).attr('id'));
    });
    return activeFilters;
};

// Function to set tournament filters active state
export const setTournamentFiltersActive = (active) => {
    tournamentFiltersActive = active;
};

// Export function to update hidden games count for specific wrapper
export const updateHiddenGamesCount = (hiddenCount, $wrapper = null) => {
    if ($wrapper && $wrapper.length > 0) {
        // Update specific wrapper
        const $showAllButton = $wrapper.find('.show_all_matches');
        if (hiddenCount > 0) {
            $showAllButton.find('.hidden_matches_count').text(hiddenCount);
            $showAllButton.show();
        } else {
            $showAllButton.hide();
        }
    } else {
        // Update all wrappers if no specific wrapper provided
        $('.show_all_matches').each(function () {
            let $currentWrapper = $(this).closest('.block__item-wrapper');
            if ($currentWrapper.find('div.games').length > 0) {
                const actualHiddenCount = $currentWrapper.find('div.games:hidden').length;
                if (actualHiddenCount > 0) {
                    $(this).find('.hidden_matches_count').text(actualHiddenCount);
                    $(this).show();
                } else {
                    $(this).hide();
                }
            }
        });
    }
};

export const showHidePlaceholder = () => {
    // Clear any existing timeout to debounce rapid calls
    if (placeholderTimeout) {
        clearTimeout(placeholderTimeout);
    }
    
    // Debounce the execution to prevent race conditions
    placeholderTimeout = setTimeout(() => {
        showHidePlaceholderImmediate();
        placeholderTimeout = null;
    }, 150);
};

const showHidePlaceholderImmediate = () => {
    // If tournament filters are active, let them manage their own empty state
    if (tournamentFiltersActive) {
        return;
    }
    
    //для каждого блока с играми
    $('.block__item-wrapper').each(function () {
        const $wrapper = $(this);
        const $games = $wrapper.find('div.games');
        const $emptyPlaceholder = $wrapper.find('.empty_placeholder');
        
        if ($games.length > 0) {
            // There are games in the DOM
            if ($games.filter(':visible').length == 0) {
                // All games are hidden by filters
                $emptyPlaceholder.show();
            } else {
                // Some games are visible
                $emptyPlaceholder.hide();
            }
        } else {
            // No games in DOM at all - could be because tournament filters removed them
            // Only show placeholder if this wrapper is supposed to have games
            // (we can detect this by checking if there are filter checkboxes that are unchecked)
            const hasUncheckedFilters = $('.filter-games-checkbox>input:not(:checked)').length > 0;
            if (hasUncheckedFilters) {
                $emptyPlaceholder.show();
            }
        }
    });
    
    // Only update hidden games count if tournament filters are NOT actively managing it
    if (!tournamentFiltersActive) {
        updateHiddenGamesCount();
    }
};